// extracted by mini-css-extract-plugin
export var headerCell = "_7e-1";
export var loadingSpinnerContainer = "_7e-4";
export var loadingStateCell = "_7e-5";
export var rowWrapper = "_7e-3";
export var standaloneTable = "_7e-6";
export var table = "_7e-0";
export var white = "_7e-2";